import { Link, useLocation } from 'react-router-dom';

export default function Navbar({ menuOpen, setMenuOpen }) {
  const location = useLocation();
  const currentPath = location.pathname; 

  // Helper to check if a path is active
  const isActive = (path) => currentPath === path;

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4 py-3">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <Link 
              to="/" 
              onClick={() => setMenuOpen(false)}
              className="flex items-center"
            >
              <i className="fa-solid fa-code text-blue-600 text-2xl mr-2"></i>
              <span className="text-xl font-bold text-blue-600">
                Devs<span className="text-blue-800">Ke</span>
              </span>
            </Link>
          </div>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8">
            <Link
              to="/"
              className={`nav-link ${isActive('/') ? 'text-blue-600 font-medium' : 'text-gray-700'}`}
            >
              Home
            </Link>
            <Link
              to="/services"
              className={`nav-link ${isActive('/services') ? 'text-blue-600 font-medium' : 'text-gray-700'}`}
            >
              Services
            </Link>
            <Link
              to="/about"
              className={`nav-link ${isActive('/about') ? 'text-blue-600 font-medium' : 'text-gray-700'}`}
            >
              About
            </Link>
            <Link
              to="/contact"
              className={`nav-link ${isActive('/contact') ? 'text-blue-600 font-medium' : 'text-gray-700'}`}
            >
              Contact
            </Link>
            <Link
              to="/quote"
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md transition duration-300"
            >
              Get Quote
            </Link>
          </div>
          
          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="text-gray-700 focus:outline-none"
            >
              <i className={`fas ${menuOpen ? 'fa-times' : 'fa-bars'} text-xl`}></i>
            </button>
          </div>
        </div>
        
        {/* Mobile Navigation */}
        {menuOpen && (
          <div className="md:hidden mt-4 pb-4">
            <div className="flex flex-col space-y-3">
              <Link
                to="/"
                onClick={() => setMenuOpen(false)}
                className={`text-left px-3 py-2 rounded-md ${isActive('/') ? 'bg-blue-100 text-blue-600' : 'text-gray-700'}`}
              >
                Home
              </Link>
              <Link
                to="/services"
                onClick={() => setMenuOpen(false)}
                className={`text-left px-3 py-2 rounded-md ${isActive('/services') ? 'bg-blue-100 text-blue-600' : 'text-gray-700'}`}
              >
                Services
              </Link>
              <Link
                to="/about"
                onClick={() => setMenuOpen(false)}
                className={`text-left px-3 py-2 rounded-md ${isActive('/about') ? 'bg-blue-100 text-blue-600' : 'text-gray-700'}`}
              >
                About
              </Link>
              <Link
                to="/contact"
                onClick={() => setMenuOpen(false)}
                className={`text-left px-3 py-2 rounded-md ${isActive('/contact') ? 'bg-blue-100 text-blue-600' : 'text-gray-700'}`}
              >
                Contact
              </Link>
              <Link
                to="/quote"
                onClick={() => setMenuOpen(false)}
                className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded-md text-left transition duration-300"
              >
                Get Quote
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}